
import { Register } from '@/api/index.js'
import { router } from '@/router/router.js'

// 注册
export function jpush() {
  document.addEventListener('deviceready', function() {
    // 第一次注册
    document.addEventListener('jpush.receiveRegistrationId', function(event) {
      console.log('receiveRegistrationId' + JSON.stringify(event))
    }, false)
    // 必须执行
    initiateUI()
  }, false)
}

export class JpushUtil {
  constructor() {
    this.pushData = []
  }
  initPush() {
    /** 接收消息触发 */
    document.addEventListener('jpush.receiveNotification', (event) => {
      const item = {
        type: event.extras.type,
        objectId: event.extras.objectId,
        alert: event.alert,
        pushId: event.extras.pushId
      }
      var jpushs = JSON.parse(localStorage.jpush) || []
      jpushs.push(item)
      localStorage.jpush(item)
    }, false)
    /** 打开消息触发 */
    document.addEventListener('jpush.openNotification', (event) => {
      router.push({ path: '/news' })
    }, false)
    /** 接收本地消息 */
    document.addEventListener('jpush.receiveLocalNotification', (event) => {
    }, false)
  }
}

// 开启
function initiateUI() {
  try {
    window.JPush.setDebugMode(true)
    window.JPush.init()
    window.setTimeout(getRegistrationID, 1000)
    // eslint-disable-next-line no-undef
    if (device.platform !== 'Android') {
      window.JPush.setApplicationIconBadgeNumber(0)
    }
  } catch (exception) {
    console.log('An exception has been occured when init JPush plugin.' + exception)
  }
}
function getRegistrationID() {
  window.JPush.getRegistrationID(onGetRegistrationID)
}
function onGetRegistrationID(data) {
  try {
    if (data.length === 0) {
      window.setTimeout(getRegistrationID, 5000)
    } else {
      var Token = localStorage.Token
      if (!Token) return
      Register(data).then(res => {
      })
    }
  } catch (exception) {
    console.log(exception)
  }
}
